var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/permalink.tsx";
const _excluded = ["className", "href", "title", "to", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { useHistory } from 'react-router-dom';
const Permalink = props => {
  const history = useHistory();
  const {
      className,
      href,
      title,
      to,
      children
    } = props,
    filteredProps = _objectWithoutProperties(props, _excluded);
  const handleClick = event => {
    if (event.button === 0 && !(event.ctrlKey || event.metaKey)) {
      event.preventDefault();
      history.push(to);
    }
  };
  return /*#__PURE__*/React.createElement("a", _extends({
    target: "_blank",
    href: href,
    onClick: handleClick,
    title: title,
    className: `permalink${className ? ' ' + className : ''}`
  }, filteredProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }), children);
};
export default Permalink;